/* eslint-disable max-lines-per-function, react/jsx-max-depth */
import { Col, Grid, withStyles } from '@kaboodle-solutions/design-system';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import HeaderLogo from '../../components/HeaderLogo';
import LoginForm from '../../components/LoginForm';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { authOperations } from '../../store/auth';
import { compose } from 'redux';
import { connect } from 'react-redux';
import constants from '../../constants';
import styles from './LoginPage.styles';
import { uiOperations } from '../../store/ui';
import { useWindowSize } from '../../hooks';

const LoginPage = ({ authenticated, loading, onSubmit, updateUI, classes }) => {
  const { BOOKINGS_URL } = constants;
  const [isVisible, setIsVisible] = useState(false);
  const refPage = useRef(null);
  const { width } = useWindowSize();
  const isDesktop = width > 720;

  useLayoutEffect(() => {
    updateUI({
      displayHeader: false,
      displayFooter: false,
    });
  }, []);

  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 100);
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const goToTop = () => {
    refPage.current.scrollIntoView({ behavior: 'smooth' });
  };

  return authenticated ? (
    <Redirect to={BOOKINGS_URL} />
  ) : (
    <>
      <div className={classes.page} ref={refPage}>
        <Grid className={classes.grid}>
          <Col lg={6}>
            <div className={classes.logoContainer}>
              <HeaderLogo />
            </div>
            <div className={classes.container}>
              <h1 className={classes.header}>Let&apos;s get you logged in</h1>
              <LoginForm
                onSubmit={onSubmit}
                loading={loading}
                isDesktop={isDesktop}
              />
              {isDesktop && (
                <h1 className={classes.header}>Need help logging in?</h1>
              )}
              <div>
                <h2>If you booked online...</h2>
                <p className={classes.content}>
                  Logging in to your Kaboodle account lets you do everything
                  from downloading your ticket to adding additional items to
                  your booking. Your account was created at the same time as
                  your booking, just use the email address and password you
                  created during the booking process.
                </p>
              </div>
              <div>
                <h2>If your booking was created for you...</h2>
                <p className={classes.content}>
                  If your booking was made for you and it&apos;s your first time
                  here, please use the &quot;Forgotten your password&quot; link
                  using the email address where you received your booking
                  confirmation and we&apos;ll email you with the next steps.
                </p>
              </div>
            </div>
          </Col>
        </Grid>
      </div>
      <div className={classes.bg}>
        <div className={classes.slice} />
        <div className={classes.loginOverlay} />
        <div className={classes.bgImage} />
      </div>
      {isVisible && !isDesktop && (
        <img
          onClick={goToTop}
          aria-hidden="true"
          className={classes.icon}
          alt=""
          src="/images/icon-arrow.svg"
        />
      )}
    </>
  );
};

LoginPage.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  classes: PropTypes.object,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  updateUI: PropTypes.func.isRequired,
};

LoginPage.defaultProps = {
  classes: {},
  loading: true,
};

const mapStateToProps = state => ({
  ...state.auth,
});

const mapDispatchToProps = {
  onSubmit: authOperations.login,
  updateUI: uiOperations.updateUI,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(LoginPage);
